// CheckoutForm.js
import React, { useEffect, useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import axios from 'axios';
import "../../css/App.css";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

const CheckoutForm = ({ onCustomerId, existingCustomerId, hasSavedPaymentMethod }) => {
  const stripe = useStripe();
  const elements = useElements();
  const userData = useSelector(state => state.user)
  const fname = useSelector(state => state.user.name);
  const lname = useSelector(state => state.user.lastName);
  const name = (fname + " " + lname).trim();
  const email = useSelector(state => state.user.email);

  const [errorMessage, setErrorMessage] = useState('');
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [responded, setResponded] = useState(false);
  const [showAttention, setShowAttention] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAddCardForm, setShowAddCardForm] = useState(false); 

  const dispatch = useDispatch();

  useEffect(() => {
    if (!responded) {
      getCustomer(email);
    }

    const timeout = setTimeout(() => {
      setShowAttention(true);
    }, 250);

    return () => clearTimeout(timeout);
  }, [responded, email, userData?.stripeCustomer?.invoice_settings?.default_payment_method, userData]);

  const getCustomer = async (email) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_CUSTOMER_EMAIL}`, {
        params: { email },
      });

      const customer = response.data;
      existingCustomerId(customer.id);
      setResponded(true);
    } catch (error) {
      // console.log('error customer', error);
    }
  };

  const enabledStep = {
    margin: '6px 0px',
    textTransform: 'uppercase',
    color: '#00B3B5',
    fontWeight: '800',
    fontSize: '24px',
    padding: '0'
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting || !stripe || !elements) return;

    setIsSubmitting(true);

    const cardElement = elements.getElement(CardElement);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
      billing_details: { email },
    });

    if (error) {
      setErrorMessage(error.message);
      setIsSubmitting(false);
    } else {
      setPaymentMethod(paymentMethod);
      try {
        const response = await axios.post(process.env.REACT_APP_SAVE_PAYMENT_METHOD, {
          name,
          email,
          paymentMethodId: paymentMethod.id,
        });
      
        const data = response.data;
        if (data.error) {
          setErrorMessage(data.error);
        } else {
          onCustomerId(data.customerId);
          dispatch({
            type: 'SET_STRIPE_CUSTOMER',
            payload: data.user.stripeCustomer,
          });
        }
      } catch (err) {
        setErrorMessage(err.message);
      }
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {hasSavedPaymentMethod && !showAddCardForm && (
        <button
          type="button"
          className="green-button"
          onClick={() => setShowAddCardForm(true)}
        >
          + Add Another Payment Method
        </button>
      )}
      {(showAddCardForm || !hasSavedPaymentMethod) && (
        <form
          className={`card-form ${
            !paymentMethod && !hasSavedPaymentMethod && showAttention ? 'attention-grabber' : ''
          }`}
          onSubmit={handleSubmit}
        >

          <input type="hidden" value={email} />
          {hasSavedPaymentMethod ? '' : <p style={enabledStep}>Step 1</p>}
          <div className="card-element">

            <CardElement />
          </div>

          <button
            type="submit"
            className="green-button"
            style={{margin: '16px 0px'}}
            disabled={!stripe || isSubmitting}
          >
            {hasSavedPaymentMethod ? "Add Additional Payment Method" : "Add Payment Method"}
          </button>

          {paymentMethod && <div>Payment Method Saved</div>}
          {errorMessage && <div className="error-message">{errorMessage}</div>}
        </form>
      )}
    </>

  );
};

export default CheckoutForm;
